import { Badge, Link, Tooltip, TooltipContent } from '@customerio/pluma-components/react';
import { isObjectAttributeIdentifier, PERMANENT_OBJECT_ATTRIBUTES } from '@/services/db/object/entity';

type ObjectAttributeTypeLabelProps = {
  attribute: string;
  /** The identifier tooltip only shows on multi-identifier workspaces. */
  isMultiIdentifier: boolean;
  /** Skip the Identifier badge (the editor rows label identifiers by section instead). */
  ignoreIdentifiers?: boolean;
};

export function ObjectAttributeTypeLabel({
  attribute,
  isMultiIdentifier,
  ignoreIdentifiers,
}: ObjectAttributeTypeLabelProps) {
  if (isObjectAttributeIdentifier(attribute)) {
    if (ignoreIdentifiers === true) {
      return null;
    }
    if (!isMultiIdentifier) {
      return <Badge color="grey">Identifier</Badge>;
    }
    return (
      <Tooltip isCustom>
        {(context) => (
          <>
            <Badge
              color="grey"
              cursor="help"
              ref={context.reference.setReference}
              {...context.reference.getReferenceProps()}
            >
              Identifier
            </Badge>
            <TooltipContent>
              An identifier is a unique value used to identify objects when adding, updating, or tracking an object.
              <br />
              <Link href="https://docs.customer.io/objects/#object-types" style={{ color: 'inherit' }} isUnderlined>
                Learn more about object identifiers
              </Link>
            </TooltipContent>
          </>
        )}
      </Tooltip>
    );
  }

  if (PERMANENT_OBJECT_ATTRIBUTES.includes(attribute)) {
    return (
      <Tooltip isCustom>
        {(context) => (
          <>
            <Badge
              color="grey"
              cursor="help"
              ref={context.reference.setReference}
              {...context.reference.getReferenceProps()}
            >
              Reserved
            </Badge>
            <TooltipContent>
              Some attribute names are reserved for special purposes in our system.
              <br />
              <Link
                href="https://docs.customer.io/journeys/attributes/#reserved-attributes"
                style={{ color: 'inherit' }}
                isUnderlined
              >
                Learn more about reserved attributes
              </Link>
            </TooltipContent>
          </>
        )}
      </Tooltip>
    );
  }

  return null;
}
